import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { DashboardCard } from './DashboardCard';
import { energyIcon, electricityCompanyLogo } from '../../../assets';
import {
  useElectricalAlertContext,
  ElectricalAlertState,
} from '../../../contexts/ElectricalAlertContext';
import { useElectricalDeviceStatus } from '../../../hooks';
import { useGetEnergySavingData } from '../../../hooks/electrical/useGetEnergySavingData';
import { ROUTE_PATHNAMES } from '../../../routes/routeConstants';
import {
  getGlowColors,
  getGradientColors,
  getIconBgColor,
  getIconColor,
  getStatusTextColor,
  Status,
} from '../../../types/Status';

const convertToStatus = (sensorStatus: import('common').SensorCardStatus): Status =>
  sensorStatus as unknown as Status;

export const EnergyCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { status } = useElectricalDeviceStatus();
  const { data: energySavings } = useGetEnergySavingData(1);
  const { alertState } = useElectricalAlertContext();

  // If there's an active alert, override status to Error
  const hasAlert = alertState === ElectricalAlertState.Alert;
  const convertedStatus = hasAlert ? Status.Error : convertToStatus(status);

  return (
    <DashboardCard
      iconSrc={energyIcon}
      iconBgColor={getIconBgColor(convertedStatus)}
      iconColor={getIconColor(convertedStatus)}
      brandLogoSrc={electricityCompanyLogo}
      middlePrimaryText={
        hasAlert ? t('electricity.unhealthy') : t('electricity.healthy')
      }
      middlePrimaryTextColor={getStatusTextColor(convertedStatus)}
      middleSecondaryText={t('electricity.systemHealth')}
      bottomPrimaryText={t('devices.energySavingAmount', {
        amount: energySavings?.[0]?.value.toFixed(2) || 0,
      })}
      bottomPrimaryTextColor="white"
      bottomSecondaryText={t('devices.dailyUsage')}
      backgroundGradientColors={getGradientColors(convertedStatus)}
      glowGradientColors={getGlowColors(convertedStatus)}
      onPress={() => navigate(ROUTE_PATHNAMES.energy)}
    />
  );
};
